// CSS Modules - component class name prefix: SocialLinks__

<template>
  <ul :class="[$style.socialLinks, 'column']">
    <li v-for="(link, index) in socialLinks" :key="index">
      <a
        :href="link.url"
        :target="link.newWindow ? '_blank' : '_self'"
        :title="link.label"
      >
        <i
          :class="[link.icon, $style.iconContainer]"
          :style="{
            background: link.color
          }"
        >
        </i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "SocialLinks",
  props: {
    socialLinks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style module lang="scss">
@import "./SocialLinks.scss";
</style>
